<!-- prize.wxml -->
<template>
    <div class="member-order-box">
        <!-- tab -->
        <div class="type-tab">
            <div v-for="(item,index) in typeList" :style="{width:100 / typeList.length + '%'}" :key="index"
                 :class="['tab-item',item.type == dataType ? ' active':'']" @click="getType(item.type)">
                <div class="item">{{item.name}}</div>
            </div>
        </div>
        <!-- tab end -->
        <!-- prize -->
        <div class="order-list" v-if="list.length > 0">
            <nut-infiniteloading
                @loadmore="onInfinite"
                :is-show-mod="true"
                :has-more="isHasMore"
                :is-loading="isLoading"
                :threshold="20"
            >
                <div class="list-item" v-for="(item,index) in list" :key="index">
                    <!--                    分割线-->
                    <div style="height: 10px;width: 300%;background: #f7f7f7;margin-left: -20px"></div>
                    <!--                    分割线 -->
                    <router-link :to="{path:'/member/order_show',query:{order_id:item.order_id}}">
                        <span style="font-weight: 500;color: #555;">商品列表</span>
                        <div style="float: right;color: #ff5656;font-size: 13px;font-weight: 500;">{{item.state_text}}
                        </div>
                        <div class="order-detail clearfix" style="border-bottom: 1px solid #eee">
                            <div class="order-on" style="font-weight: 400;color: #777">订单号：{{item.order_no}}</div>
                            <div class="time" style="color: #777">{{item.create_time}}</div>
                        </div>
                        <div class="goods-list-box">
                            <div class="goods-list clearfix">
                                <div class="image" v-for="(good,gindex) in item.goods" :key="gindex" v-if="gindex < 4">
                                    <img :src="good.image.file_path"/>
                                </div>
                                <div style="float:right;margin-top: 5%;color: #777;">
                                    <span>共 {{item.goods.length}} 件 </span>
                                    <i class="iconfont icon-jiantou1"></i>
                                </div>
                            </div>
                        </div>
                    </router-link>
                    <div class="lan-box">
                        <div class="total">
                            <span class="text">合计：</span>
                            <span class="col-m">${{item.pay_price_my}}</span>
                        </div>
                        <div class="order-right">
                            <div v-if="item.order_status.value != 20">
                                <!-- 未支付取消订单 -->
                                <div v-if="item.pay_status.value==10">
                                    <div class="btn-default" style="color: #777;border: 1px solid #777;"
                                         @click="cancelOrder(item.order_id)">取消订单
                                    </div>
                                </div>
                                <!-- 已支付取消订单 -->
                                <div v-if="item.order_status.value!=21">
                                    <div v-if="item.pay_status.value==20 && item.delivery_status.value==10">
                                        <div class="btn-default" @click="cancelOrder(item.order_id)">申请取消</div>
                                    </div>
                                    <div
                                        v-if="item.pay_status.value==20 && item.delivery_type.value == DeliveryTypeEnum.EXTRACT.value && item.delivery_status.value == 10">
                                        <div class="btn-default" @click="onExtractQRCode(item.order_id)">核销码</div>
                                    </div>
                                </div>
                                <div v-else>
                                    <span class="btn-default" style="color: #777;border: 1px solid #777;">取消申请中</span>
                                </div>
                                <!-- 订单付款 -->
                                <div v-if="item.pay_status.value==10">
                                    <div class="btn-default" @click="onPayOrder(item.order_id)">付款</div>
                                </div>
                                <!-- 确认收货 -->
                                <div v-if="item.delivery_status.value==20 && item.receipt_status.value == 10">
                                    <div class="btn-default" @click="receipt(item.order_id)">确认收货</div>
                                    <router-link :to="{path:'/order/express?order_id='+item.order_id}"
                                                 class="btn-default" @click="receipt(item.order_id)">查看物流
                                    </router-link>
                                </div>
                                <div v-if="item.order_status.value==30 && item.is_comment==0">
                                    <router-link :to="{path:'/member/order_show',query:{order_id:item.order_id}}"
                                                 class="btn-default">去评价
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nut-infiniteloading>
        </div>
        <!-- no-result -->
        <div class="noresult" v-else>
            <div class="cot">
                <div class="img">
                    <img src="../../assets/images/no_result.png">
                </div>
                <p class="text" style="color: #aaa">暂无订单信息</p>
                <router-link class="browse-btn" to="/">点击逛逛</router-link>
            </div>
        </div>
        <nut-popup :style="{ width: '80%',height: '100px',borderRadius: '5px' }" v-model="isPay">
            <div class="pay-title">请选择支付方式</div>
            <div class="pay-type-list" @click="payment">
                微信支付
            </div>
            <div class="pay-type-list" @click="paymentCard">
                信用卡支付
            </div>
        </nut-popup>
        <!-- no-result end -->
        <nut-popup :style="{ padding: '30px 20px',borderRadius:'10px',width:'280px',height:'280px' }"
                   v-model="showQRCodePopup">
            <img :src="QRCodeImage">
        </nut-popup>
        <nut-drag direction="y" :style="{right:'0px',bottom:'150px'}">
            <nut-fixednav active-text="收起导航" un-active-text="快速导航" :nav-list="NAVLIST"
                          @selected="selectedNav"></nut-fixednav>
        </nut-drag>
    </div>
</template>
<script>
import Tabber from '@/components/Tabber.vue'
// 枚举类：发货方式
import DeliveryTypeEnum from '../../utils/enum/DeliveryType.js';
// 枚举类：支付方式
import PayTypeEnum from '../../utils/enum/order/PayType'

export default {
    name: 'MemberOrder',
    components: {
        Tabber,
        DeliveryTypeEnum,
        PayTypeEnum
    },
    data() { //默认数据
        return {
            dataType: 'all',
            isShow: true,
            typeList: [
                {
                    name: '全部',
                    type: 'all',
                },
                {
                    name: '待支付',
                    type: 'payment',
                },
                {
                    name: '待发货',
                    type: 'delivery',
                },
                {
                    name: '查看物流',
                    type: 'received',
                },
                {
                    name: '待评价',
                    type: 'comment',
                },
                {
                    name: '已完成',
                    type: 'commentok',
                }
            ],
            list: [],
            DeliveryTypeEnum, // 配送方式
            PayTypeEnum, // 支付方式
            no_more: false, // 没有更多数据
            page: 1, // 当前页码
            current_page: 1,
            last_page: 1,
            isHasMore: true,
            isLoading: false,
            showQRCodePopup: false, // 核销码弹窗显示隐藏
            QRCodeImage: '', // 核销码图片
            pay_order_id: 0,
            isPay: false,
        }
    },
    created() { //视图加载前执行
        let _this = this;
        this.loading = this.$toast.loading('Loading...', {
            coverColor: "rgba(0,0,0,0.5)",
        });
    },
    mounted() { //视图加载完成执行
        let _this = this;
        _this.dataType = _this.$route.query.type || 'all';
        // 获取订单列表
        _this.getOrderList();
    },
    methods: {

        /**
         * 获取订单列表
         */
        getOrderList(page = 1) {
            let _this = this;
            _this._get('user.order/lists', {
                page: page,
                dataType: _this.dataType
            }, result => {
                let resList = result.data.list;
                _this.list = _this.list.concat(resList.data)
                _this.loading.hide();
                _this.isLoading = false;
                _this.isHasMore = resList.data.length > 0 ? true : false;
            });
        },


        /**
         * 顶部切换事件
         */
        getType: function (type) {
            let _this = this;
            _this.dataType = type;
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            _this.list = [];
            _this.getOrderList();
        },

        /**
         * 取消订单
         */
        cancelOrder(order_id) {
            let _this = this;
            _this.$dialog({
                title: "友情提示",
                content: "确认要取消该订单吗？",
                onOkBtn(event) {
                    _this._post_form('user.order/cancel', {
                        order_id
                    }, result => {
                        _this.$toast.success('订单取消成功,已付款订单需商家审核!', {
                            onClose: function () {
                                _this.list = [];
                                _this.getOrderList();
                            }
                        });
                    });
                    this.close(); //关闭对话框
                }
            });
        },

        /**
         * 确认收货
         */
        receipt(order_id) {
            let _this = this;
            _this.$dialog({
                title: "友情提示?",
                content: "确认收到商品？",
                onOkBtn(event) {
                    _this._post_form('user.order/receipt', {
                        order_id
                    }, result => {
                        _this.list = [];
                        _this.getOrderList();
                    });
                    this.close(); //关闭对话框
                }
            });
        },

        /**
         * 点击付款按钮
         */
        onPayOrder(order_id) {
            let _this = this;
            _this.pay_order_id = order_id;
            _this.isPay = true;
        },

        /**
         * 发起付款请求
         */
        payment(orderId, payType = 20) {
            let _this = this;
            // 显示loading
            this.loading = this.$toast.loading('交易处理中...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            _this._post_form('user.order/pay', {
                order_id: _this.pay_order_id,
                payType: payType,
                sss: 'h5',
                client: 'h5',
            }, result => {
                _this.loading.hide();
                if (result.code == -10) {
                    _this.$toast.fail(result.msg);
                } else {
                    window.location.href = result.data.payment.mweb_url;
                }
            });
        },

        paymentCard(orderId, payType = 30) {
            let _this = this;
            // 显示loading
            this.loading = this.$toast.loading('交易处理中...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            _this._post_form('user.order/creditCarPay', {
                order_id: _this.pay_order_id,
                payType: payType,
                sss: 'h5',
                client: 'h5',
            }, result => {
                _this.loading.hide();
                if (result.url) {
                    window.location.href = result.url;
                } else {
                    _this.$toast.fail('订单支付失败');
                }
            });
        },

        /**
         * 查看核销二维码
         */
        onExtractQRCode(order_id) {
            let _this = this;
            // 调用后台api获取核销二维码
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            _this._get('user.order/extractQrcode', {
                order_id
            }, (result) => {
                _this.loading.hide();
                // 设置二维码图片路径
                _this.setData({
                    QRCodeImage: result.data.qrcode,
                    showQRCodePopup: true, // 显示核销码
                });
            });
        },

        /**
         *  触底加载
         */
        onInfinite: function () {
            if (this.current_page >= this.last_page) {
                this.isLoading = false;
                this.isHasMore = false;
                return false;
            }
            this.isLoading = true;
            this.isHasMore = true;
            this.getOrderList(this.current_page + 1);
        },
    },
    destroyed() {
        let _this = this;
        //切记页面销毁需要销毁
        _this.loading.hide();
    }
}
</script>
<style lang="scss">
@import "order.scss";
</style>
